import React, { useState, useEffect } from 'react'

// List of neon colors
const neonColors = [
    '#39FF14',  // Neon Green
    '#FF10F0',  // Neon Pink
    '#1F51FF',  // Neon Blue
    '#FFFF33',  // Neon Yellow
    '#FF6F00',  // Neon Orange
    '#9B00FF',  // Neon Purple
    '#FF073A',  // Neon Red
    '#00FF00',  // Neon Lime
    '#FF00FF'   // Neon Magenta
];

const Slide4Achievement = ({ content }) => {
    const [data, setData] = useState('')
    /*  const getRandomNeonColor = () => {
         const randomIndex = Math.floor(Math.random() * neonColors.length);
         
         let randomColor = neonColors[randomIndex];
         // console.log('randomColor',randomColor)
         return randomColor;
     }; */
    // Array to store previously generated colors
    let usedColors = [];

    // Function to generate a random neon color
    const getRandomNeonColor = () => {
        let color;
        do {
            // Randomly generate a neon color using HSL (Hue, Saturation, Lightness)
            const hue = Math.floor(Math.random() * 360); // Hue (0 to 360 degrees)
            const saturation = 100; // Full saturation (maximum vibrant color)
            const lightness = Math.floor(Math.random() * 30) + 40; // Lightness (values between 40 and 70 for neon effect)

            // Convert HSL to CSS-compatible string
            color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;

        } while (usedColors.includes(color)); // Ensure no repetition of colors

        // Store the generated color to avoid future repetition
        usedColors.push(color);

        return color;
    };
    useEffect(() => {
        // console.log(content)
    }, [])
    /* useEffect(() => { 
        let contentStr = ''
        // console.log(content)
        for(let i = 0; i<content.length;i++){
            // console.log(content[i].txt)
            contentStr += content[i].txt;
        }
        // console.log(contentStr)
        setData(contentStr)
    }, []) */
    return (
        <div className="col-lg-12 col-md-12 col-sm-12 col-centered">
            {content && content.length > 0 && content.map((obj, index) => {
                const randomColor = getRandomNeonColor();
                const alignment = index % 2 === 1 ? 'flex-end' : 'flex-start';
                const textDirection = index % 2 === 1 ? 'text-right' : 'text-left';

                return (
                    <div
                        key={index}
                        className={textDirection}
                        style={{
                            color: randomColor,
                            height: '20vh',
                            justifyContent: alignment,
                            paddingLeft: index % 2 === 1 ? '20%' : '30px',
                            paddingRight: index % 2 === 0 ? '20%' : '30px',
                        }}
                        dangerouslySetInnerHTML={{ __html: obj.txt }}
                    />
                );
            })}
        </div>

    );
}

export default Slide4Achievement